import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Removed GlobalStyle import here as it's handled within App.tsx via ThemeProvider

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);